import { IPaginatedResponse } from '@/services/api.ts';

export type TUser = {
  id: number;
  email: string;
  site_id: number;
  name: string;
  surname: string;
  phone: string;
  full_name: string;
  admin: boolean;
  company_id: number;
  company_name: string;
  company: TCompany;
  rep: TUser;
  rep_name: string;
  roles: TRole[];
  timezone: string;
};

type TRole = 'superadministrator' | 'administrator' | 'samplesDepartment' | 'customer' | 'designer';

export type TCompany = {
  id: number;
  site_id: number;
  name: string;
};

export function userCanEditProducts(user?: TUser) {
  if (!user || !user.roles) {
    return false;
  }
  return (
    user.roles.includes('superadministrator') ||
    user.roles.includes('administrator') ||
    user.roles.includes('samplesDepartment')
  );
}

export enum ProductTypeEnum {
  CUSTOM = 0,
  BROADLOOM = 1,
  RUG = 2,
}

export type TAdminProduct = {
  id: number;
  name: string;
  type_name: string;
  visibility: string;
  availability: string;
  rating: number;
  cost_str: string;
  product_type: ProductTypeEnum;
  construction: {
    id: number;
    name: string;
  }[];
  patterns: {
    id: number;
    name: string;
  }[];
  material: {
    id: number;
    name: string;
  }[];
  color: {
    id: number;
    name: string;
    visibility: string;
    availability: string;
    primary: {
      id: number;
      name: string;
    }[];
    secondary: {
      id: number;
      name: string;
    }[];
  };
};

export type TFacet = {
  name: string;
  value: string | number;
  count: number;
};

export type TFilter = {
  label: string;
  key: string;
  value: string | number;
};

export type TColorItem = {
  id: number;
  name: string;
};

export type TListColor = {
  id: number;
  name: string;
  c_p: TColorItem[];
  c_s: TColorItem[];
  img: string;
};

export type TListProduct = {
  id: number;
  name: string;
  colors: TListColor[];
  type: number;
  img?: string;
  in_projects?: boolean;
  price?: number;
  size_str?: string;
};

export interface IProductsRes extends IPaginatedResponse<TListProduct> {
  facets?: {
    type?: TFacet[];
    c_p?: TFacet[];
    construction?: TFacet[];
    pattern?: TFacet[];
    material?: TFacet[];
    mat_cat?: TFacet[];
    coll_id?: TFacet[];
    category?: TFacet[];
  };
  filters?: TFilter[];
  items: TListProduct[];
  pagination: {
    per_page: number;
    start: number;
    total: number;
  };
}

export type TProduct = {
  id: number;
  name: string;
  availability: string;
  visibility: string;
  type: string;
  looks: string;
  country: string;
  construction: string;
  materials: string;
  size_label: string;
  size_str: string;
  patterns: string;
  pattern_repeat: string;
  img_full: string;
  colors: TProductColor[];
  in_projects?: boolean;
};

export type TProductColor = {
  id: number;
  name: string;
  availability: string;
  visibility: string;
  img_full: string;
  img_thumb: string;
};

export function getImgOrNoPreview(imgUrl?: string) {
  const previewImg = '/media/no-preview.png';
  if (!imgUrl || imgUrl.includes('no-preview')) {
    return previewImg;
  }
  return imgUrl;
}


export type TMemo = {
  id: number;
  due_date: string;
  shipped_date: string;
  status: string;
  project: {
    id: number;
    name: string
  },
  items: TMemoItem[],
  signature: {
    date: string;
    img_url: string;
  }
}

export type TMemoItem = {
  id: number;
  barcode: string;
  img_url: string;
  name: string;
  status: string;
  type: string;
  product_id: number;
  color_id: number;
};

export type TProject = {
  id: number;
  created_at: string;
  name: string;
  client: string;
  items: TProjectItem[];
  shipping_address?: TShippingAddress
}

export type TProjectItem = {
  id: number;
  name: string;
  img_url: string;
  area: string;
  product_id: number;
  color_id: number;
  product_name: string;
  color_name: string;
}

export type TShippingAddress = {
  id: number;
  company_name: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  full: string;
  one_line: string;
};